import React from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'

import PlaceIcon from '../../Icons/Place'

const Overview = ({selectedPlace}) => {
  const { t } = useTranslation()

  return (
    <div className={styles.container}>
      {
        selectedPlace 
          ? <div>
            </div>
          : <div className={styles.emptyContainer}>
              <PlaceIcon width={67} height={77} color="#0789FF" className={styles.placeIcon} />
              <div style={{textTransform: 'uppercase'}}>{ t('Nothing selected') }</div>
              <div>{ t('Please select a project or a place to get detailed information') }</div>
            </div>
      }
    </div>
  )
}

export default Overview
